/**
 * WordPress dependencies.
 */
import { Inserter } from '@wordpress/block-editor';
import { Button } from '@wordpress/components';

const BlockAppenderButton = ( { clientId, label } ) => {
	return <Inserter
		rootClientId={ clientId }
		renderToggle={ ( { onToggle, disabled } ) => (
			<div className="gutenify-block-list-appender">
				<Button
					className="my-button-block-appender"
					onClick={ onToggle }
					disabled={ disabled }
					label={ label }
					variant="primary"
				>{ label }
				</Button>
			</div>
		) }
		isAppender
	/>;
};

export default BlockAppenderButton;
